import Intercom, {shutdown} from '@intercom/messenger-js-sdk'
import {UserModel} from 'app/features/auth/models/UserModel'
import intercomService from 'app/services/IntercomService'
import {jwtDecode} from 'jwt-decode'
import {useEffect, useState} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from 'setup'

const INTERCOM_USER_HASH_KEY = 'intercom_access_token'

// Helper to decode JWT and check expiration using jwt-decode
function isJwtExpired(token: string | null): boolean {
  if (!token) return true
  try {
    const payload: {exp?: number} = jwtDecode(token)
    if (!payload.exp) return true
    const now = Math.floor(Date.now() / 1000)
    const isExpired = payload.exp < now
    if (isExpired) {
      clearIntercomSession()
    }
    return isExpired
  } catch (e) {
    return true
  }
}

const IntercomSDK = (): any => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [userHash, setUserHash] = useState<string | null>(null)
  const [isFetched, setIsFetched] = useState(false)

  useEffect(() => {
    const getUserHash = async () => {
      let hash = sessionStorage.getItem(INTERCOM_USER_HASH_KEY)
      if (isJwtExpired(hash)) {
        hash = await intercomService.fetchIntercomJwt()
        if (hash) {
          sessionStorage.setItem(INTERCOM_USER_HASH_KEY, hash)
        } else {
          sessionStorage.removeItem(INTERCOM_USER_HASH_KEY)
        }
      }
      setUserHash(hash)
    }
    getUserHash().finally(() => {
      setIsFetched(true)
    })
  }, [])

  // Wait until fetch is complete
  if (!isFetched) {
    return null
  }

  const company = {
    id: user.email,
    name: user.store?.name,
  }

  return Intercom({
    app_id: 'aypj9f4e',
    user_id: user.store?.name,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    company,
    companies: [company],
    user_hash: userHash ?? undefined,
  })
}
export default IntercomSDK

export const clearIntercomSession = () => {
  shutdown()
  sessionStorage.removeItem(INTERCOM_USER_HASH_KEY)
}
